import { Injectable } from '@angular/core';
import { HttpService } from '../providers/http.service';
import { AppConfig } from '../app/app.config';
@Injectable()
export class TransferRecordService {

    constructor(
        private httpService: HttpService) { }

    //获取用户的提现记录
    getTransferRecord(
        userName:string,
        startDate:string,
        endDate:string,
        pageSize:number,
        pageIndex:number
        ) {
        var url = AppConfig.GetProdUrl()+ "/User/transReport?userName="+userName+"&startDate="+startDate+"&endDate="+endDate+"&pageSize="+pageSize+"&pageIndex="+pageIndex;
        return this.httpService.get(url);
    }

}


// WEBPACK FOOTER //
// ./src/services/transferRecord.service.ts